import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import moment from 'moment';
import { toast } from 'react-toastify';




export default function IC_supplier_order({ data, entity = null, setDataKeyValue }) {

    async function getInternal() {
        if (entity === 'supplier_order') {


            if (data.typeOrder && data.typeOrder.value === "10_PRODUZIONE_INTERNA") {
                let constraints = [
                    { fieldName: "defaultSupplier", type: "value", value: 1 }
                ]
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var res = await DataManager.searchItems('warehouse', 1, 5, sorting, '', [], constraints);
                if (res.success === 1 && res.body.length > 0) {
                    if (data.idWarehouseFinish !== null) {
                        if (data.idWarehouseFinish.id !== res.body[0].id) {
                            setDataKeyValue('idWarehouseFinish', res.body[0])
                        }
                    } else {
                        setDataKeyValue('idWarehouseFinish', res.body[0])
                    }
                    console.log(res)
                    if (data.idWarehouseStart !== null) {
                        if (data.idWarehouseStart.id !== res.body[0].id) {
                            setDataKeyValue('idWarehouseStart', res.body[0])
                        }
                    } else {
                        setDataKeyValue('idWarehouseStart', res.body[0])
                    }


                }
                let constraints1 = [
                    { fieldName: "defaultSupplierInternal", type: "value", value: 1 }
                ]
                var sorting1 = {
                    'field': 'id',
                    'order': 'desc'
                }
                var res1 = await DataManager.searchItems('movement_scope', 1, 5, sorting1, '', [], constraints1);
                if (res1.success === 1) {
                    if (data.scope !== "") {
                        if (data.scope.id !== res1.body[0].id) {
                            setDataKeyValue('scope', res1.body[0])
                        }
                    }
                }
                if (data.idForwarder === "") {
                    let constraints2 = [
                        { fieldName: "isDefault", type: "value", value: 1 }
                    ]
                    var sorting2 = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var res2 = await DataManager.searchItems('forwarder', 1, 5, sorting2, '', [], constraints2);
                    if (res2.success === 1) {
                        if (data.idForwarder.id !== res2.body[0].id) {
                            setDataKeyValue('idForwarder', res2.body[0])
                        }
                    }
                }


            }
            if (data.typeOrder && data.typeOrder.value === "5_MATERIA_PRIMA") {
                let constraints = [
                    { fieldName: "defaultSupplier", type: "value", value: 1 }
                ]
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var res = await DataManager.searchItems('warehouse', 1, 5, sorting, '', [], constraints);
                if (res.success === 1 && res.body.length > 0) {
                    if (data.idWarehouseFinish === "") {
                        setDataKeyValue('idWarehouseFinish', res.body[0])
                    }
                }
                let constraints1 = [
                    { fieldName: "defaultSupplierMP", type: "value", value: 1 }
                ]
                var sorting1 = {
                    'field': 'id',
                    'order': 'desc'
                }
                var res1 = await DataManager.searchItems('movement_scope', 1, 5, sorting1, '', [], constraints1);
                if (res1.success === 1) {
                    if (data.scope === "") {
                        if (data.scope.id !== res1.body[0].id) {
                            setDataKeyValue('scope', res1.body[0])
                        }
                    }
                }
            }
            if (data.typeOrder && (data.typeOrder.value === "0_CONTO_LAVORO" || data.typeOrder.value === "15_RIPRISTINO")) {
                if (data.idWarehouseFinish === '') {
                    let constraints = [
                        { fieldName: "defaultSupplier", type: "value", value: 1 }
                    ]
                    var sorting = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var res = await DataManager.searchItems('warehouse', 1, 5, sorting, '', [], constraints);
                    if (res.success === 1 && res.body.length > 0) {
                        if (data.idWarehouseFinish !== res.body[0]) {
                            setDataKeyValue('idWarehouseFinish', res.body[0])
                        }

                    }
                }

                if (data.scope === "") {
                    let constraints1 = [
                        { fieldName: "defaultSupplierCL", type: "value", value: 1 }
                    ]
                    var sorting1 = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var res1 = await DataManager.searchItems('movement_scope', 1, 5, sorting1, '', [], constraints1);
                    if (res1.success === 1) {
                        if (data.scope === "") {
                            setDataKeyValue('scope', res1.body[0])

                        }
                    }
                }
                if (data.idForwarder === "") {
                    let constraints2 = [
                        { fieldName: "isDefault", type: "value", value: 1 }
                    ]
                    var sorting2 = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var res2 = await DataManager.searchItems('forwarder', 1, 5, sorting2, '', [], constraints2);
                    if (res2.success === 1) {
                        setDataKeyValue('idForwarder', res2.body[0])

                    }
                }

            }
        }

    }

    useEffect(() => {
        if (data.typeOrder && data.typeOrder.value === "10_PRODUZIONE_INTERNA") {
            getInternal();
        }
        if (data.typeOrder && data.typeOrder.value === "5_MATERIA_PRIMA") {
            getInternal();
        }
        if (data.typeOrder && data.typeOrder.value === "0_CONTO_LAVORO") {
            getInternal();
        }
        if (data.typeOrder && data.typeOrder.value === "15_RIPRISTINO") {
            getInternal();
        }
        console.warn(data);
        var warehouseField = document.getElementById("supplier_order_field_idWarehouseStart");
        var itemsAspectField = document.getElementById("supplier_order_field_itemsAspect");
        var transportByField = document.getElementById("supplier_order_field_transportBy");
        var forwarderField = document.getElementById("supplier_order_field_idForwarder");
        if (data.typeOrder && data.typeOrder.value === "5_MATERIA_PRIMA") {
            forwarderField.style.display = 'none';
            itemsAspectField.style.display = 'none';
            transportByField.style.display = 'none';
            warehouseField.style.display = 'none';

            if (data.idForwarder !== "") {
                setDataKeyValue('idForwarder', "")
            }
            if (data.itemsAspect?.value !== '' || data.itemsAspect === "") {
                if (data.itemsAspect !== null) {
                    setDataKeyValue('itemsAspect', null)
                }
            }
            if (data.transportBy?.value !== '' || data.transportBy === "") {
                if (data.transportBy !== null) {
                    setDataKeyValue('transportBy', null)
                }

            }


        } else {
            warehouseField.style.display = 'block';
            itemsAspectField.style.display = 'block';
            transportByField.style.display = 'block';
            forwarderField.style.display = 'block';
        }

        if (data.orderDate === null || data.orderDate === '') {
            var t = moment().format("YYYY-MM-DD")
            setDataKeyValue('orderDate', t)
        }
        //FORNITORE
        if (data.idSupplier && data.idSupplier !== '' && data.idSupplier !== null) {
            localStorage.setItem('idSupplierOfficeOrder', data.idSupplier.id)
            if (data.discount1 === "0" || data.discount1 === "") {
                setDataKeyValue('discount1', data.idSupplier.discount1)
            }
            if (data.idVatCondition === "") {
                if (data.idVatCondition !== data.idSupplier.idVatCondition) {
                    setDataKeyValue('idVatCondition', data.idSupplier.idVatCondition)
                }
            }
            if (data.discount2 === "0" || data.discount2 === "") {
                setDataKeyValue('discount2', data.idSupplier.discount2)
            }
            if (data.discount3 === "0" || data.discount3 === "") {
                setDataKeyValue('discount3', data.idSupplier.discount3)
            }
            if (data.idPaymentCondition === "" && (data.idPaymentCondition !== data.idSupplier.idPaymentCondition)) {
                setDataKeyValue('idPaymentCondition', data.idSupplier.idPaymentCondition)
            }
            if (data.idWarehouseStart === "" && data.idSupplier.idWarehouse !== null && data.idWarehouseStart !== data.idSupplier.idWarehouse) {
                setDataKeyValue('idWarehouseStart', data.idSupplier.idWarehouse)
            }
            if (!data.address && data.idSupplier.offices) {
                getSupplier();
            }
        } else {
            localStorage.removeItem('idSupplierOfficeOrder')
        }






        if (data.rows && data.rows.length > 0) {
            var deliveryDate = data.rows.filter(item => item.expectedDate !== "").reduce((latest, order) => new Date(order.expectedDate) > latest ? new Date(order.expectedDate) : latest, new Date(0));
            if (data.deliveryDate !== moment(deliveryDate).format('YYYY-MM-DD')) {
                setDataKeyValue('deliveryDate', moment(deliveryDate).format('YYYY-MM-DD'))
            }

            var totale = data.rows.reduce((acc, cur) => acc + parseFloat(cur.totalRow), 0);
            var totaleIva = data.rows.reduce((acc, item) => acc + ((parseFloat(item.totalRow) * parseFloat(item.idVatCondition ? item.idVatCondition.percentage : 1)) / 100), 0);
            var weight = data.rows.reduce((acc, cur) => acc + (parseFloat(cur.grossWeight)), 0);

            if (parseFloat(data.totalIva).toFixed(2) !== parseFloat(totaleIva).toFixed(2)) {
                setDataKeyValue('totalIva', parseFloat(totaleIva).toFixed(2));
            }
            if(parseInt(data.weight) === 0 || data.weight === "") {
                if (parseFloat(data.weight).toFixed(2) !== parseFloat(weight).toFixed(2)) {
                    setDataKeyValue('weight', parseFloat(weight).toFixed(2));
                }
            }


            if (parseFloat(data.totalImponibile).toFixed(2) !== parseFloat(totale).toFixed(2)) {
                setDataKeyValue('totalImponibile', parseFloat(totale).toFixed(2));
            }
            if (data.totalImponibile !== "" && data.totalIva !== "") {
                var a = parseFloat(data.totalImponibile) + parseFloat(data.totalIva);
                console.log(parseFloat(a).toFixed(2));
                if (data.totalPrice !== parseFloat(a).toFixed(2)) {
                    setDataKeyValue('totalPrice', parseFloat(a).toFixed(2));
                }
            }
        }
    }, [data]);



    useEffect(() => {
        if (window.location.pathname === "/entity/supplier_order/add") {
            //FORNITORE
            if (data.idSupplier && data.idSupplier !== '' && data.idSupplier !== null) {
                if (data.notes !== data.idSupplier.notes) {
                    setDataKeyValue('notes', data.idSupplier.notes)
                }
                if (data.idVatCondition === "") {
                    if (data.idVatCondition !== data.idSupplier.idVatCondition) {
                        setDataKeyValue('idVatCondition', data.idSupplier.idVatCondition)
                    }
                }
                if (data.discount1 !== data.idSupplier.discount1) {
                    setDataKeyValue('discount1', data.idSupplier.discount1)
                }
                if (data.discount2 !== data.idSupplier.discount2) {
                    setDataKeyValue('discount2', data.idSupplier.discount2)
                }
                if (data.discount3 !== data.idSupplier.discount3) {
                    setDataKeyValue('discount3', data.idSupplier.discount3)
                }
                if (data.idPaymentCondition !== data.idSupplier.idPaymentCondition) {
                    setDataKeyValue('idPaymentCondition', data.idSupplier.idPaymentCondition)
                }
                if (data.idWarehouseStart !== data.idSupplier.idWarehouse) {
                    setDataKeyValue('idWarehouseStart', data.idSupplier.idWarehouse)
                }
                if (!data.address && data.idSupplier.offices) {
                    getSupplier()
                }
            }
        }



    }, [data.idSupplier]);






    useEffect(() => {
        if (entity !== 'supplier_order') {
            return;
        }

        const container = document.getElementById('supplier_order_field_deliveryDate');

        if (!container) {
            return;
        }

        let button = document.getElementById('btn_copy_supplier_order_delivery_date');

        if (!button) {
            button = document.createElement('button');
            button.id = 'btn_copy_supplier_order_delivery_date';
            button.classList.add('btn', 'btn-primary', 'mt-2', 'btn-sm');
            button.textContent = 'Copia data su tutte le righe';
            container.appendChild(button);
        }

        button.onclick = (event) => {
            event.preventDefault();

            if (!data.deliveryDate || !data.rows || !Array.isArray(data.rows) || data.rows.length === 0) {
                if (!data.deliveryDate) {
                    toast.error('Impostare la data di consegna in testata.', { theme: 'colored' });
                } else if (!data.rows || !Array.isArray(data.rows) || data.rows.length === 0) {
                    toast.error('Non sono presenti righe nell\'ordine.', { theme: 'colored' });
                }
                return;
            }

            const updatedRows = data.rows.map((row) => ({
                ...row,
                expectedDate: data.deliveryDate,
            }));

            setDataKeyValue('rows', updatedRows);
        };
    }, [entity, data.deliveryDate, data.rows, setDataKeyValue]);





    async function getSupplier() {
        var res = await DataManager.getItem('supplier', data.idSupplier.id);
        if (res.success === 1) {
            for (var i = 0; i < res.body[0].offices.length; i++) {
                var item = res.body[0].offices[i];
                if (item.isDeliveryDefault === 1) {
                    setDataKeyValue('address', item)
                }
            }
        }
    }





    return (
        <>

            {data.idSupplier && data.idSupplier.internalNotes !== "" ?
                <Alert variant="warning" dismissible>
                    <Alert.Heading>Istruzioni a operatore</Alert.Heading>
                    <p>
                        {data.idSupplier.internalNotes}
                    </p>
                </Alert>
                : <></>}

        </>
    )
};
